import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'
import {camelCase, castAttributesForCamelCase} from '../../../modules/string_converter'
import { retryPromise } from '../../../modules/retryPromise'

export const companiesStorePosts = {
  namespaced: true,
  state: {
    formValues: {
      stores: []
    }, // 店舗一覧を選ぶときの状態管理
    // 以下、API に POST・PATCH するときのデータの状態管理
    post: {
      id: null,
      topicType: '',
      notes: [],
      stores: [],
      docomoStores: [],
      yahooMapStores: [],
      storeUuids: [],
      storeCount: {},
      storeErrorCount: 0,
      publishedAt: new Date,
      postImages: [],
      title: '',
      summary: '',
      category: {},
      callToAction: {
        actionType: 'ACTION_TYPE_UNSPECIFIED',
        url: '',
      },
      event: {
        title: '',
        startedAt: new Date(),
        endedAt: new Date(),
      },
      offer: {
        couponCode: '',
        redeemOnlineUrl: '',
        termsConditions: '',
      },
      sameContentsExist: false,
      services: ['google_map', 'docomo', 'yahoo_map'],
      docomo: {
        postToBrandPage: true,
      },
    },
    eventTime: false,
    eventStartedTime: '00:00',
    eventEndedTime: '00:00',
    reservationDateTime: null,
    posts: [],
    postCounts: {},
    meta: {
    },
    approvalInitMeta: {},
    selectedTopicType: '',
    selectedPostStatusType: 'POST',
    selectedApprovalStatusType: 'all',
    submitActionModalType: '',
    approvalRequestNotes: '',
    previewLoading: false,
    repeatingPost: false,
    repeatingPostScheduleKind: 'weekly',
    postLoading: false,
    submitProcessing: false,
  },
  getters: {
    post: (state) => state.post,
    isNewPost: (state) => {
      return !state.post.id
    },
    selectedPostStatusType: (state) => {
      return state.selectedPostStatusType
    },
    postStatusTypes: () => {
      return {
        POST: i18n.t('models.gmb.postStatusType.post'),
        RESERVING: i18n.t('models.gmb.postStatusType.reservingPost'),
        IN_PROGRESS: i18n.t('models.gmb.postStatusType.inProgress'),
        DRAFT: i18n.t('models.gmb.postStatusType.draft')
      }
    },
    topicTypes: () => {
      return {
        STANDARD: i18n.t('models.gmb.topicType.standard'),
        EVENT: i18n.t('models.gmb.topicType.event'),
        OFFER: i18n.t('models.gmb.topicType.offer'),
      }
    },
    actionTypes: () => {
      return {
        ACTION_TYPE_UNSPECIFIED: i18n.t('models.gmb.actionType.unspecified'),
        BOOK:  i18n.t('models.gmb.actionType.book'),
        ORDER:  i18n.t('models.gmb.actionType.order'),
        SHOP:  i18n.t('models.gmb.actionType.shop'),
        LEARN_MORE:  i18n.t('models.gmb.actionType.learnMore'),
        SIGN_UP:  i18n.t('models.gmb.actionType.signUp'),
        CALL: i18n.t('models.gmb.actionType.call'),
      }
    },
    timeList: () => {
      const timeArray = []
      for (let step = 0; step < 24; step++) {
        timeArray.push({ name: `${('00' + step).slice(-2)}:00`, id: `${('00' + step).slice(-2)}:00` } )
        timeArray.push({ name: `${('00' + step).slice(-2)}:30`, id: `${('00' + step).slice(-2)}:30`} )
      }
      return timeArray
    },
    eventStartedAt: (state) => {
      let startedAt

      if (state.eventTime) {
        const startedTime = state.eventStartedTime.split(':')
        startedAt = new Date(
          state.post.event.startedAt.getFullYear(),
          state.post.event.startedAt.getMonth(),
          state.post.event.startedAt.getDate(),
          Number(startedTime[0]),
          Number(startedTime[1]),
        )
      } else {
        startedAt = new Date(
          state.post.event.startedAt.getFullYear(),
          state.post.event.startedAt.getMonth(),
          state.post.event.startedAt.getDate(),
          0,
          0,
          0,
        )
      }

      return startedAt
    },
    eventEndedAt: (state) => {
      let endedAt

      if (state.eventTime) {
        const endedTime = state.eventEndedTime.split(':')
        endedAt = new Date(
          state.post.event.endedAt.getFullYear(),
          state.post.event.endedAt.getMonth(),
          state.post.event.endedAt.getDate(),
          Number(endedTime[0]),
          Number(endedTime[1]),
        )
      } else {
        endedAt = new Date(
          state.post.event.endedAt.getFullYear(),
          state.post.event.endedAt.getMonth(),
          state.post.event.endedAt.getDate(),
          23,
          59,
          59,
        )
      }

      return endedAt
    },
    selectTopicType: (state, getters) => {
      return getters.topicTypes[state.post.topicType]
    },
    selectActionType: (state, getters) => (actionType) => {
      return getters.actionTypes[actionType]
    },
    showEventType: (state) => {
      return (state.post.topicType === 'EVENT') || (state.post.topicType === 'OFFER')
    },
    showCallToActionType: (state) => {
      const isOnlyYahooMapPost = state.post.services.length === 1 && state.post.services.includes('yahoo_map')
      if (isOnlyYahooMapPost) return false
      return state.post.topicType !== 'OFFER'
    },
    showOfferType: (state) => {
      return state.post.topicType === 'OFFER'
    },
    findPosts: (state) => (id) => {
      return state.posts.find(post => post.id == id)
    },
    selectedTopicType: (state) => {
      return state.selectedTopicType
    },
    showSubmitActionModalType: (state) => {
      return state.submitActionModalType
    },
    storeTotalCount(state) {
      return state.formValues.stores.length
    },
  },
  mutations: {
    setFormValues(state, value) {
      setFormValues(state, value)
    },
    setFilterValues(state, payload) {
      setFilterValues(state, payload)
    },
    toggleFilterValues(state, payload) {
      toggleFilterValues(state, payload)
    },
    updateRepeatingPostScheduleKind(state, kind) {
      state.repeatingPostScheduleKind = kind
    },
    updateRepeatingPost(state, value) {
      state.repeatingPost = value
    },
    updateDocomoPostToBrandPage(state, value) {
      state.post.docomo.postToBrandPage = value
    },
    updateSelectedApprovalStatusType(state, type) {
      state.selectedApprovalStatusType = type
    },
    updateSelectedPostStatusType(state, type) {
      state.selectedPostStatusType = type
    },
    updateTopicType(state, topicType) {
      state.post.topicType = topicType
    },
    updateSelectedTopicType(state, topicType) {
      state.selectedTopicType = topicType
    },
    updateStoreUuids(state, storeUuids) {
      state.post.storeUuids = storeUuids
    },
    updateSummary(state, summary) {
      state.post.summary = summary
    },
    updateCategory(state, categoryId) {
      state.post.category.id = categoryId
    },
    updateCallToAction(state, actionType) {
      state.post.callToAction.actionType = actionType
    },
    updateCallToActionUrl(state, url) {
      state.post.callToAction.url = url
    },
    updatePostTitleText(state, title) {
      state.post.title = title
    },
    updateEventTitleText(state, title) {
      state.post.event.title = title
    },
    updateStartedAt(state, startedAt) {
      state.post.event.startedAt = startedAt
    },
    updateEndedAt(state, endedAt) {
      state.post.event.endedAt = endedAt
    },
    updateCouponCode(state, couponCode) {
      state.post.offer.couponCode = couponCode
    },
    updateServices(state, services) {
      state.post.services = services
    },
    updateRedeemOnlineUrl(state, redeemOnlineUrl) {
      state.post.offer.redeemOnlineUrl = redeemOnlineUrl
    },
    updateTermsConditions(state, termsConditions) {
      state.post.offer.termsConditions = termsConditions
    },
    updatePostImages(state, { data, name }) {
      const payload = {
        id: data.data.id,
        name: name,
        url: data.data.attributes.url,
      }
      state.post.postImages.push(payload)
    },
    removePostImages(state, id) {
      state.post.postImages = state.post.postImages.filter(image => {
        return image.id !== id
      })
    },
    updateEventTime(state, eventTime) {
      state.eventTime = eventTime
    },
    updateEventStartedTime(state, eventStartedTime) {
      state.eventStartedTime = eventStartedTime
    },
    updateEventEndedTime(state, eventEndedTime) {
      state.eventEndedTime = eventEndedTime
    },
    updateReservationDateTime(state, reservationDateTime) {
      state.reservationDateTime = reservationDateTime
    },
    updateSubmitActionModalType(state, submitActionModalType) {
      state.submitActionModalType = submitActionModalType
    },
    updatePosts(state, data) {
      state.posts = data.map(v => {
        return castAttributesForCamelCase(v.attributes)
      })
    },
    setMeta(state, meta) {
      state.meta = meta
    },
    updatePostCounts(state, data) {
      const counts = castAttributesForCamelCase(data)
      state.postCounts = {
        post: counts.publishedPostsCount,
        draft: counts.draftedPostsCount,
        reserving: counts.reservingPostsCount,
        inProgress: counts.inProgressPostsCount
      }
    },
    setApprovalInitMeta(state, meta) {
      state.approvalInitMeta = meta
    },
    // 複製時には一部内容は引き継がれない
    setPost(state, { data, isCopied }) {
      const post = data.attributes

      const services = []
      if (post.stores.length) {
        services.push('google_map')
      }
      if (post.docomo_stores.length) {
        services.push('docomo')
      }
      if (post.yahoo_map_stores.length) {
        services.push('yahoo_map')
      }
      state.post.services = services
      state.post.topicType = post.topic_type
      state.selectedTopicType = post.topic_type
      state.post.stores = Object.values(castAttributesForCamelCase(post.stores)) // 投稿店舗一覧モーダル用に
      state.post.docomoStores = Object.values(castAttributesForCamelCase(post.docomo_stores)) // 投稿店舗一覧モーダル用に
      state.post.yahooMapStores = Object.values(castAttributesForCamelCase(post.yahoo_map_stores)) // 投稿店舗一覧モーダル用に
      // 詳細取得時、編集時はpostToBrandPageのdefaultはfalse, 投稿店舗一覧でレコードがない場合でもブランド投稿するように出てしまうため
      state.post.docomo = post.docomo ? castAttributesForCamelCase(post.docomo) : { postToBrandPage: false }
      state.post.storeUuids = Array.from(new Set([...state.post.stores.map(s => s.uuid), ...state.post.docomoStores.map(s => s.uuid), ...state.post.yahooMapStores.map(s => s.uuid)]))

      if (!isCopied) {
        state.post.id = post.id
        state.post.publishedAt = post.published_at ? new Date(post.published_at) : null
        state.reservationDateTime = post.scheduled_at ? new Date(post.scheduled_at) : null
        if (post.notes) {
          state.post.notes = post.notes.map((note) => {
            return {
              kind: note.kind,
              body: note.body,
              commenterName: note.commenter_name,
              commentedAt: note.commented_at
            }
          })
        }
        if (post.repeat_configuration) {
          state.repeatingPost = true
          state.repeatingPostScheduleKind = camelCase(post.repeat_configuration.kind)
        }
        if (post.same_content_post_exist) {
          state.post.sameContentsExist = post.same_content_post_exist
        }
      }

      if (post.title) state.post.title = post.title
      if (post.summary) state.post.summary = post.summary
      if (post.category) state.post.category = post.category
      if (post.call_to_action) {
        state.post.callToAction.actionType = post.call_to_action.action_type
        state.post.callToAction.url = post.call_to_action.url
      }
      if (post.post_images) {
        state.post.postImages = post.post_images
      }
      if (post.offer) {
        if (post.offer.coupon_code) state.post.offer.couponCode = post.offer.coupon_code
        if (post.offer.redeem_online_url) state.post.offer.redeemOnlineUrl = post.offer.redeem_online_url
        if (post.offer.terms_conditions) state.post.offer.termsConditions = post.offer.terms_conditions
      }
      state.postLoading = false
    },
    setPostEvent(state, { data, isCopied }) {
      const post = data.attributes

      if (!post.event) {
        return
      }
      state.post.event.title = post.event.title

      if (isCopied) {
        state.eventTime = false
        return
      }

      state.post.event.startedAt = new Date(post.event.started_at)
      state.post.event.endedAt = new Date(post.event.ended_at)

      const times = [
        [
          new Date(post.event.started_at).getHours(),
          new Date(post.event.started_at).getMinutes(),
          new Date(post.event.started_at).getSeconds(),
        ],
        [
          new Date(post.event.ended_at).getHours(),
          new Date(post.event.ended_at).getMinutes(),
          new Date(post.event.ended_at).getSeconds(),
        ]
      ]
      // '00:00' の形式にしている
      state.eventStartedTime = `${10 > times[0][0] ? `0${times[0][0]}` : times[0][0]
      }:${10 > times[0][1] ? `0${times[0][1]}` : times[0][1]
      }`
      state.eventEndedTime = `${10 > times[1][0] ? `0${times[1][0]}` : times[1][0]
      }:${10 > times[1][1] ? `0${times[1][1]}` : times[1][1]
      }`

      if (state.eventStartedTime === '00:00' && state.eventEndedTime === '23:59') {
        state.eventTime = false
      } else {
        state.eventTime = true
      }
    },
    resetPost(state) {
      state.post.id = null
      state.post.topicType = ''
      state.post.postImages = []
      state.post.stores = []
      state.post.storeUuids = []
      state.post.publishedAt = new Date
      state.post.title = ''
      state.post.summary = ''
      state.post.category = {}
      state.post.callToAction = {
        actionType: 'ACTION_TYPE_UNSPECIFIED',
        url: '',
      }
      state.post.event = {
        title: '',
        startedAt: new Date(),
        endedAt: new Date(),
      }
      state.post.offer = {
        couponCode: '',
        redeemOnlineUrl: '',
        termsConditions: '',
      }
      state.post.services = []
      state.post.docomo = {
        postToBrandPage: true
      }
      state.selectedTopicType = ''
      state.eventTime = false
      state.eventStartedTime = '00:00'
      state.eventEndedTime = '00:00'
      state.reservationDateTime = null
      state.post.notes = []
      state.repeatingPost = false
      state.repeatingPostScheduleKind = 'weekly'
    },
    resetPosts(state) {
      state.formValues = {
        stores: []
      }
      state.posts = []
    },
    setImmediatePost(state) {
      state.repeatingPost = false
      state.repeatingPostScheduleKind = 'weekly'
      state.reservationDateTime = null
    },
    setPostStores(state, data) {
      state.post.stores = Object.values(castAttributesForCamelCase(data.attributes.stores)) // 投稿店舗一覧モーダル用に
      state.post.docomoStores = Object.values(castAttributesForCamelCase(data.attributes.docomo_stores)) // 投稿店舗一覧モーダル用に
      state.post.yahooMapStores = Object.values(castAttributesForCamelCase(data.attributes.yahoo_map_stores)) // 投稿店舗一覧モーダル用に
    },
    setSameContentsExistFlag(state, data) {
      state.post.sameContentsExist = data.attributes.same_content_post_exist
    },
    updateApprovalRequestNotes(state, notes) {
      state.approvalRequestNotes = notes
    },
    resetPostImages(state) {
      state.post.postImages = []
    },
    preparePostApiConnect(state) {
      state.postLoading = true
    },
    postApiFailure(state) {
      state.postLoading = false
    },
    prepareSubmitApiConnect(state) {
      state.submitProcessing = true
    },
    submitApiSuccess(state) {
      state.submitProcessing = false
    },
    submitApiFailure(state) {
      state.submitProcessing = false
    }
  },
  actions: {
    resetPostImages({ commit }) {
      commit('resetPostImages')
    },
    setImmediatePost({ commit }) {
      commit('setImmediatePost')
    },
    updateSubmitActionModalType({ commit }, submitActionModalType) {
      commit('updateSubmitActionModalType', submitActionModalType)
    },
    updateApprovalRequestNotes({ commit }, notes){
      commit('updateApprovalRequestNotes', notes)
    },
    updateApprovalRequest({ rootState, commit}, payload) {
      commit('prepareSubmitApiConnect')
      const postId = payload.id
      const isApprove = payload.isApprove

      let targetEndpoint
      let params

      if(isApprove){
        targetEndpoint = '/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + postId + '/request_approval'
        params = {
          request_approval: {
            comment: payload.approvalRequestNotes
          }
        }
      } else {
        targetEndpoint = '/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + postId + '/request_reject_note'
        params = {
          request_reject_note: {
            body: payload.approvalRequestNotes
          }
        }
      }

      return axios
        .post(targetEndpoint, params)
        .then(() => {
          const messageType = isApprove ? 'approvedPostRequest' : 'rejectedPostRequest'
          commit('flash/updateFlash', { type: 'notice', message: i18n.t(`pages.CompaniesStorePost.${messageType}`) }, { root: true })
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    createPost({ rootState, commit }, payload) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/posts', payload)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    updatePost({ rootState, commit }, { values, id }) {
      commit('prepareSubmitApiConnect')
      return axios
        .put('/api/companies/' + rootState.route.params.company_uuid + '/posts/' + id, values)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    postPostImage({ commit }, { companyUuid, fileName, postImage }) {
      const payload = {
        post_image: {
          content: postImage,
          filename: fileName,
        }
      }

      return axios
        .post('/api/companies/' + companyUuid + '/posts/images', payload)
        .then(res => {
          const payload = {
            data: res.data,
            name: fileName
          }
          commit('updatePostImages', payload)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deletePostImage({ commit }, { companyUuid, id }) {
      return axios
        .delete('/api/companies/' + companyUuid + '/posts/images/' + id)
        .then(() => {
          commit('removePostImages', id)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readPosts({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/posts/search', payload)
        .then(res => {
          commit('updatePosts', res.data.data)
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readPostsForFilter({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/posts/search', payload)
        .then(res => {
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    getPost({ commit }, { companyUuid, id, isCopied = false }) {
      commit('resetPost')
      commit('preparePostApiConnect')
      return axios
        .get('/api/companies/' + companyUuid + '/posts/' + id)
        .then(res => {
          commit('setPost', { data: res.data.data, isCopied: isCopied })
          commit('setPostEvent', { data: res.data.data, isCopied: isCopied })
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('postApiFailure')
        })
    },
    deletePost({ commit }, { companyUuid, id }) {
      return axios
        .delete('/api/companies/' + companyUuid + '/posts/' + id)
        .then(() => {
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deletedDelay', { value: i18n.t('layouts.sideMenu.operation.gmbPosts.name') }) }, { root: true })
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createPreview({ rootState, commit }, payload) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/posts/previews', payload)
        .then((res) => {
          commit('submitApiSuccess')
          commit('setPostStores', res.data.data)
          commit('setSameContentsExistFlag', res.data.data)
          return true
        }).catch(err => {
          commit('submitApiFailure')
          alert(err.response.data.errors[0])
          return false
        })
    },
    createRequestingPostPreview({ rootState, commit }, payload) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/previews', payload)
        .then((res) => {
          commit('submitApiSuccess')
          commit('setPostStores', res.data.data)
          commit('setSameContentsExistFlag', res.data.data)
          return true
        }).catch(err => {
          commit('submitApiFailure')
          alert(err.response.data.errors[0])
          return false
        })
    },
    createRequestingPost({ commit, rootState }, payload ) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts', payload)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    updateRequestingPost({ commit, rootState }, { id, values } ) {
      commit('prepareSubmitApiConnect')
      return axios
        .patch('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + id, values)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('submitApiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    readRequestingPosts({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/search', payload)
        .then(res => {
          commit('updatePosts', res.data.data)
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readRequestingPostsForFilter({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/search', payload)
        .then(res => {
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    getRequestingPost({ commit, rootState }, { id, isCopied = false }) {
      commit('resetPost')
      commit('preparePostApiConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + id)
        .then(res => {
          commit('setPost', { data: res.data.data, isCopied: isCopied })
          commit('setPostEvent', { data: res.data.data, isCopied: isCopied })
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deleteRequestingPost({ commit, rootState }, id ) {
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + id)
        .then(() => {
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    createPostAfterRequesting({ commit, rootState }, { payload, id }) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + id + '/post', payload)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    deleteRequestApprovingPost({ commit, rootState }, requestingPostId ) {
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + requestingPostId + '/request_approving_post')
        .then(() => {
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    readDraftedPosts({ commit, rootState }, payload) {
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts', { params: payload })
        .then(res => {
          commit('updatePosts', res.data.data)
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readDraftedPost({ commit, rootState }, { id, isCopied = false }) {
      commit('resetPost')
      commit('preparePostApiConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts/' + id)
        .then(res => {
          commit('setPost', { data: res.data.data, isCopied: isCopied })
          commit('setPostEvent', { data: res.data.data, isCopied: isCopied })
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createDraftedPost({ commit, rootState }, payload ) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts', payload)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    returnToDraftedPost({ commit, rootState }, { id, values } ) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/posts/' + id + '/drafted_posts', values)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    returnRequestingPostToDraftedPost({ commit, rootState }, { id, values } ) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/requesting_posts/' + id + '/drafted_posts', values)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    updateDraftedPost({ commit, rootState }, { id, values } ) {
      commit('prepareSubmitApiConnect')
      return axios
        .put('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts/' + id, values)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    deleteDraftedPost({ commit, rootState }, draftPostId ) {
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts/' + draftPostId)
        .then(() => {
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    createPostAfterDraft({ commit, rootState }, {payload, draftedPostId} ) {
      commit('prepareSubmitApiConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/drafted_posts/' + draftedPostId + '/posts', payload)
        .then(() => {
          commit('submitApiSuccess')
          return true
        })
        .catch(err => {
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('submitApiFailure')
          return false
        })
    },
    readPostCounts({ commit, rootState } ) {
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/posts/counts' )
        .then(res => {
          commit('updatePostCounts', res.data.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    updateTitleText({ commit }, { topicType, title }) {
      if (topicType === 'STANDARD') {
        commit('updatePostTitleText', title)
      } else {
        commit('updateEventTitleText', title)
      }
    },
    updateStoreUuids({ commit }, storeUuids) {
      commit('updateStoreUuids', storeUuids)
    },
    async generateAiPost({ rootState }, { keywords, url, appeal }) {
      const response = await axios.post(`/api/companies/${rootState.route.params.company_uuid}/ai/posts`, {
        keywords,
        url,
        appeal
      })
      const retryFunc = () => {
        return axios.get(`/api/companies/${rootState.route.params.company_uuid}/ai/posts/${response.data.id}`)
      }
      const evalFunc = (result) => {
        const isPolling = result.data.status === 'processing'
        return !isPolling
      }
      return retryPromise(retryFunc, evalFunc, 3000)
    }
  }
}
